/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isSelectedPlan: (state) => {
        if (state.global !== null && state.global !== undefined) {
          if (
            state.global.selectedPlan !== null &&
            state.global.selectedPlan !== undefined &&
            state.global.selectedProduct !== null &&
            state.global.selectedProduct !== undefined
          )
            return true;
          return false;
        }
        return false;
      },
      selectedPlan: (state) => state.global.selectedPlan,
      selectedProduct: (state) => state.global.selectedProduct,
      selectedProductVideoUrl: (state) => state.global.selectedProductVideoUrl,
      selectedProductSlug: (state) => state.global.selectedProductSlug,
      selectedProductName: (state) => state.global.selectedProductName,
      blogPosts: (state) => state.posts.list,
      // TODO: seperate email from product getters
      email: (state) => (state.auth.loggedIn ? state.auth.user.email : null),
    }),
  },
};
